"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = __importDefault(require("lodash"));
exports.default = (function (props) { return (react_1.default.createElement("div", { className: "input textarea flex flex-row" },
    react_1.default.createElement("label", { htmlFor: "ta_" + props.name },
        lodash_1.default.startCase(props.name.replace(/-/g, " ")),
        ":"),
    react_1.default.createElement("textarea", __assign({}, props, { value: props.value || "", id: "ta_" + props.name })))); });
